import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=73af8a16&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./DistributorList.vue?vue&type=style&index=0&id=73af8a16&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "73af8a16",
  "6111bc63"
  
)

export default component.exports